const strong_lines_list = [
    {"name": "NP_237","name_hyphen":"Np-237", "lines":[86.5,143]},
    {"name": "CO_57","name_hyphen":"Co-57", "lines":[57,122,136]},
    {"name": "PU_238","name_hyphen":"Pu-238", "lines":[153,766]},
    {"name": "PU_239","name_hyphen":"Pu-239", "lines":[129,375,414]},
    {"name": "PU_240","name_hyphen":"Pu-240", "lines":[160,642]},
    {"name": "RGPU","name_hyphen":"RGPU", "lines":[129,375,414]},
    {"name": "WGPU","name_hyphen":"WGPU", "lines":[129,375,414]},
    {"name": "DU","name_hyphen":"DU", "lines":[186,1001,766]},
    {"name": "LEU","name_hyphen":"LEU", "lines":[186,143,163,205]},
    {"name": "HEU","name_hyphen":"HEU", "lines":[186,143,163,205]},
    {"name": "U_235","name_hyphen":"U-235", "lines":[186,143,163,205]},
    {"name": "U_238","name_hyphen":"U-238", "lines":[186,1001,766]},
    {"name": "AM_241","name_hyphen":"Am-241", "lines":[59.5,662,722]},
    {"name": "CF_252","name_hyphen":"Cf-252", "lines":[]},
    {"name": "CO_60","name_hyphen":"Co-60", "lines":[1173,1333]},
    {"name": "CS_137","name_hyphen":"Cs-137", "lines":[662]},
    {"name": "IR_192","name_hyphen":"Ir-192", "lines":[317,468,308,296,604,612,589]},
    {"name": "SE_75","name_hyphen":"Se-75", "lines":[265,136,280,121,401]},
    {"name": "SR_90","name_hyphen":"Sr-90", "lines":[]},
    {"name": "SB_124","name_hyphen":"Sb-124", "lines":[603,1691,723,646,2091]},
    {"name": "BA_133","name_hyphen":"Ba-133", "lines":[356,81,303,384,276]},
    {"name": "CD_109","name_hyphen":"Cd-109", "lines":[88]},
    {"name": "KR_85","name_hyphen":"Kr-85", "lines":[514]},
    {"name": "NA_22","name_hyphen":"Na-22", "lines":[511,1275,1786]},
    {"name": "CS_131","name_hyphen":"Cs-131", "lines":[30,34]},
    {"name": "CR_51","name_hyphen":"Cr-51", "lines":[320]},
    {"name": "F_18","name_hyphen":"F-18", "lines":[511]},
    {"name": "GD_153","name_hyphen":"Gd-153", "lines":[97,103]},
    {"name": "GA_67","name_hyphen":"Ga-67", "lines":[93,185,300,394,209,888]},
    {"name": "GE_68","name_hyphen":"Ge-68", "lines":[511,1077]},
    {"name": "I_123","name_hyphen":"I-123", "lines":[159,27,31,529]},
    {"name": "I_125","name_hyphen":"I-125", "lines":[27,31,35]},
    {"name": "I_131","name_hyphen":"I-131", "lines":[365,637,284,80,723]},
    {"name": "LU_177","name_hyphen":"Lu-177", "lines":[208,113,321,250]},
    {"name": "LU_177M","name_hyphen":"Lu-177m", "lines":[208,228,379,419,327,414]},
    {"name": "MO_99","name_hyphen":"Mo-99", "lines":[141,740,181,778]},
    {"name": "PD_103","name_hyphen":"Pd-103", "lines":[40,357,497]},
    {"name": "P_32","name_hyphen":"P-32", "lines":[]},
    {"name": "RB_82","name_hyphen":"Rb-82", "lines":[511,777,1395]},
    {"name": "SM_153","name_hyphen":"Sm-153", "lines":[103,70]},
    {"name": "TC_99M","name_hyphen":"Tc-99m", "lines":[141]},
    {"name": "TL_201","name_hyphen":"Tl-201", "lines":[167,135]},
    {"name": "XE_133","name_hyphen":"Xe-133", "lines":[81]},
    {"name": "LA_138","name_hyphen":"La-138", "lines":[1436,789]},
    {"name": "LU_176","name_hyphen":"Lu-176", "lines":[307,202]},
    {"name": "K_40","name_hyphen":"K-40", "lines":[1461]},
    {"name": "RA_226","name_hyphen":"Ra-226", "lines":[609,352,295,1764,1120]},
    {"name": "TH_232","name_hyphen":"Th-232", "lines":[239,2614,583,911,969]},
    {"name": "EU_152","name_hyphen":"Eu-152", "lines":[344,1408,964]},
    {"name": "EU_154","name_hyphen":"Eu-154", "lines":[123,1274]},
    {"name": "MN_56","name_hyphen":"Mn-56", "lines":[845,1811]},
    {"name": "W_187","name_hyphen":"W-187", "lines":[686,480]},
    {"name": "XRAY","name_hyphen":"XRAY", "lines":[61.5]}
];

export default strong_lines_list;
